/*
    Update product price based on flashlight selection
    require: sections\main-product-clear-stix.liquid script ld+json
*/
document.addEventListener("DOMContentLoaded", function () {

    // Product data
    const raw_data = document.querySelector("script#product-clear-stick-variants").innerHTML;
    if(!raw_data){
        return console.log("Cant find script with product variants data")
    }
    const {data} = JSON.parse(raw_data);
    
    if(data.variants.length === 0){
        return console.log("Null variants for flashlight options data")
    }
   //console.log("flashlight data:", data)
   
   // helpers
    function formatMoney(cents, format) {
        const moneyFormat = '${{amount}}';

        if (typeof cents === 'string') {
        cents = cents.replace('.', '');
        }
        let value = '';
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        const formatString = format || moneyFormat;

        function formatWithDelimiters(
        number,
        precision = 2,
        thousands = ',',
        decimal = '.'
        ) {
        if (isNaN(number) || number == null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            `$1${thousands}`
        );
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
        }

        switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
        }

        return formatString.replace(placeholderRegex, value);
    }

    function variantUpdate(cb = ()=>{}){
        setTimeout(() => {
            const variant_url = new URLSearchParams(window.location.search).get("variant");
            //console.log(variant_url);
            
            // no variant selected - get default price
            if(variant_url == null){
                return cb()
            }

            // selected variant 
            const variant = data.variants.filter(variant => variant.id == Number(variant_url))
            const active = document.querySelector('.additional_products__item .active').dataset.jsAdditionalProductPrice

            const formated_total = Number(variant[0].price) + Number(active)
            const price_total = formatMoney(formated_total, '{{ amount }}')
            const price_dom = document.querySelector(".product-page-info__price [data-js-product-price]")
            
            if(!price_dom){
                console.log("Product price DOM not founded")
                return;
            }

            price_dom.innerText = `$${price_total}`

            return variant_url
        }, 1000);
    }


   // variant on change url, no need to add a listener to each variant option
    navigation.addEventListener("navigate", e => {
        variantUpdate()
    });

   // flashlight options
    const flashlights_dom = document.querySelectorAll("[data-js-additional-product-item-img]"); 

    if (flashlights_dom.length === 0 ) {
        console.log("Additional product, can't found flashlights DOM elements.");
        return;
    }

    flashlights_dom.forEach(flashlight => {
        flashlight.addEventListener('click', (e)=>{
            const { jsAdditionalProductId, jsAdditionalProductPrice } = e.target.dataset;
            //console.log( {jsAdditionalProductPrice });

            if(!jsAdditionalProductPrice ||  !jsAdditionalProductId){
                console.log("Additional product, can't found DOM container product price or variant id")
                return;
            }

            // no variant selected - get default price
            variantUpdate( function(){
               const formated_total = Number(data.price) + Number(jsAdditionalProductPrice)
               const price_total = formatMoney(formated_total, '{{ amount }}')
               const price_dom = document.querySelector(".product-page-info__price [data-js-product-price]")
                
                if(!price_dom){
                    console.log("Product price DOM not founded")
                    return;
                }

                price_dom.innerText = `$${price_total}`
                //alert(price_total)
                return
             })
          
        })
    })
})